module.exports = __webpack_public_path__ + "static/img/tst2-09.d1df06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-09.jpg
// module id = m4tI
// module chunks = 1